import * as React from 'react';
import classnames from 'classnames';

import AttachmentImage from './AttachmentImage';

import './style.scss';

export interface IAttachmentDisplayProps {
  onClick: (imageIndex: number) => (e: React.SyntheticEvent<any>) => void;
  fileName: string;
  fileURL: string;
  clickableText: string;
  primaryText: string;
  secondaryText: string;
  displayIndex?: number;
}

interface IAttachmentDisplayState {}

export default class AttachmentDisplay extends React.Component<IAttachmentDisplayProps, IAttachmentDisplayState> {
  getFileType = (fileName: string) => {
    const fileNameSplit: string[] = fileName.split('.');
    const fileNameExtension: string = fileNameSplit[fileNameSplit.length - 1];

    // TODO: this function should handle all file types, currently
    // only images are checked for.
    if (/(jpe?g|png)$/.test(fileNameExtension.toLowerCase())) {
      return 'image';
    } else {
      return 'others';
    }
  };

  getThumb = (fileName: string, fileURL: string) => {
    const defaultClassName = 'attachment-display__thumb';

    const fileTypeToThumb = {
      image: (
        <AttachmentImage
          onClick={this.props.onClick(this.props.displayIndex)}
          className={classnames(defaultClassName)}
          src={fileURL}
          alt={fileName || 'Attachment thumbnail'}
        />
      ),
      others: <div className={classnames(defaultClassName, `${defaultClassName}--others`)} />,
    };

    return (
      fileTypeToThumb[this.getFileType(fileName)] || (
        <div className={classnames(defaultClassName, `${defaultClassName}--others`)} />
      )
    );
  };

  render() {
    const { clickableText, fileName, fileURL, primaryText, secondaryText, displayIndex } = this.props;

    return (
      <div key={displayIndex} className={classnames('attachment-display')}>
        {this.getThumb(fileName, fileURL)}
        <div className={classnames('attachment-display__photo-details')}>
          <a onClick={this.props.onClick(displayIndex)} className={classnames('attachment-display__clickable')}>
            {clickableText}
          </a>
          <label className={classnames('attachment-display__primary')}>{primaryText}</label>
          <label className={classnames('attachment-display__secondary')}>{secondaryText}</label>
        </div>
      </div>
    );
  }
}
